@if (notificationService.polledNotifications$ | async; as notifications) {
  <div class="dropdown notifications" ngbDropdown placement="bottom-start">
    <button class="btn-notification" type="button" ngbDropdownToggle aria-haspopup="true" aria-expanded="true" [ngClass]="{'new': notifications.length > 0}">
      <!--combine the two below and use [ngClass]-->
      @if (notifications.length > 0) {
        <div class="notification-bell">
          <span class="fa-stack">
            <i class="fas fa-bell-on fa-stack"></i>
            <span class="fa fa-stack fa-inverse">
              <span class="bell-counter">
                <!--{{notifications.length}}-->
              </span>
            </span>
          </span>
        </div>
      }
      @if (notifications.length == 0) {
        <div class="notification-bell inactive">
          <i class="fas fa-bell"></i>
        </div>
      }
      <span class="notifications-app-aside-text">&nbsp; Notifications</span>
    </button>
    @if (notifications.length > 0) {
      <div ngbDropdownMenu class="dropdown-menu notifications-dropdown-menu has-notifications">
        <div class="col-12">
          <div class="row">
            <div class="notifications-clear-all col-12 px-0">
              <button (click)="notificationService.dismissAll( notifications );" class="btn btn-link">Clear All</button>
            </div>
          </div>
          @for (notification of notifications; track notification.Id) {
            <div class="row row-notif-striped">
              <!-- Should we add a column for type of notification? -->
              <div class="col-1 notification-icon-circle">
                <div class="notification-read-indicator">
                  <i class="fas fa-circle"></i>
                </div>
              </div>
              <div class="col-9">
                <div class="notification-title row ps-1">
                  @if (notification.Url) {
                    <a href="{{ notification.Url }}">{{ notification.Title }}</a>
                  }
                  @if (!notification.Url) {
                    <span>{{ notification.Title }}</span>
                  }
                </div>
                <div class="notification-message row ps-3">
                  {{ notification.Details }}
                </div>
              </div>
              <div class="col-1">
                <div class="notification-dismiss">
                  <button (click)="notificationService.dismissNotification( notification )" aria-label="Dismiss Notification" class="btn btn-primary btn-sm">
                    <i class="fas fa-check"></i>
                    @if (notification.isBeingDismissed) {
                      <i class="fas fa-circle-notch fa-spin"></i>
                    }
                  </button>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
    @if (notifications.length == 0) {
      <div ngbDropdownMenu class="dropdown-menu notifications-dropdown-menu no-notifications">
        <span>You currently have no new notifications. Do some fun stuff!</span>
      </div>
    }
  </div>
} @else {
}

